module.exports = __webpack_public_path__ + "img/gato-01.aecaab75.png";